/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_Base_UrlInputs */

const vi_smartlab_settings_base_url = /** @type {(inputs: Smartlab_Settings_Base_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ máy chủ (Base URL)`)
};

/**

* @param {Smartlab_Settings_Base_UrlInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_base_url = /** @type {((inputs?: Smartlab_Settings_Base_UrlInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_Base_UrlInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_base_url(inputs)
});